export default __webpack_public_path__ + "static/media/double-tap.addbbf16.png";